// http://sachinchoolur.github.io/lightGallery/docs/
// import $ from "jQuery"
// import "lightgallery.js"
require('lightgallery.js')
require('lg-thumbnail.js')
require('lg-video.js')
import "video.js/dist/video.js"

export const lightbox = [ '$timeout', function($timeout){
    return {
        link: function(scope, elem, attrs) {
            lightGallery(elem[0],{
                selector: ".js-lightbox-link",
                thumbnail: attrs.lightboxThumbs === 'false' ? false : true,
                exThumbImage: 'data-exthumbimage',
                download: false,
                videojs: true
            })
        }
    }
}]
